import moment from 'moment/moment';

const DATE_FORMAT = 'YYYY年MM月DD日（dd）';

let MINDATE;
if (moment().hour() >= 12) {
  MINDATE = moment().add(1, 'days');
} else {
  MINDATE = moment();
}

const PICKER_CONFIG = {
  minDate: MINDATE.format('YYYY-MM-DD'),

  locale: {
    format: DATE_FORMAT,
    separator: ' 〜 ',
    fromLabel: '開始',
    toLabel: '終了',
    weekLabel: '週',
    daysOfWeek: [
      '日',
      '月',
      '火',
      '水',
      '木',
      '金',
      '土'
    ],
    monthNames: [
      '1月',
      '2月',
      '3月',
      '4月',
      '5月',
      '6月',
      '7月',
      '8月',
      '9月',
      '10月',
      '11月',
      '12月'
    ],
    firstDay: 1,
    cancelLabel: 'キャンセル',
    applyLabel: '適用'
  }
};

/**
 * DatePicker
 * @require daterangepicker
 * @require moment
 */
;(() => {
  const expr = '.js-date-picker';
  const init = () => {
    const _config = PICKER_CONFIG;
    _config.singleDatePicker = true;
    $(expr).daterangepicker(_config);
  };
  $(init);
})();

/**
 * DateRangePicker
 * @require daterangepicker
 * @require moment
 */
;(() => {
  const expr = '.js-date-range-picker';
  const init = () => {
    const _config = PICKER_CONFIG;
    $(expr).daterangepicker(_config);
  };
  $(init);
})();
